import { IStore } from 'redux/IStore';
import { IPage } from 'models/common';
import { actions as notifActions } from 'redux-notifications';
import * as i18n from 'i18next';
import { IOrdersData, IOrdersAction } from 'models/orders/orders';
import { IOrderListItem } from 'models/orders/order';
import { OrderStatus } from 'models';
import { getShopOrder } from '../shopordercard';
const { notifSend } = notifActions;

/** Action Types */
export const REQUEST_START: string = 'shoporders/REQUEST_START';
export const REQUEST_FAILURE: string = 'shoporders/REQUEST_FAILURE';
export const GET_SUCCESS: string = 'shoporders/GET_SUCCESS';
export const GET_ORDER_SUCCESS: string = 'shoporders/GET_ORDER_SUCCESS';
export const RESET_DATA: string = 'shoporders/RESET_DATA';
export const SET_ITEMS_PAGE: string = 'shoporders/SET_ITEMS_PAGE';
export const RESET_FILTERS: string = 'shoporders/RESET_FILTERS';
export const SET_SORT_FILTER: string = 'shoporders/SET_SORT_FILTER';
export const SET_ISFIRSTLOAD: string = 'shoporders/SET_ISFIRSTLOAD';
export const SET_KEYWORD_FILTER: string = 'shoporders/SET_KEYWORD_FILTER';
export const SET_NEXTPAGE: string = 'shoporders/SET_NEXTPAGE';

/** Initial State */
const initialState: IOrdersData = {
	items: [],
	isFetching: false,
	itemsPage: {
		currentPage: 0,
		totalPages: 0,
		totalItems: 0,
		itemsPerPage: 10,
		items: [],
	},
	sortFilter: null,
	keywordFilter: null,
	isFirstLoad: false,
	bookedOrder: null,
};

/** Reducer */
export function shopOrdersReducer(state = initialState, action: IOrdersAction) {
	switch (action.type) {
		case REQUEST_START:
			return Object.assign({}, state, {
				isFetching: true,
				error: false,
			});

		case GET_SUCCESS:
			return Object.assign({}, state, {
				items: action.payload.items,
				isFetching: false,
			});

		case GET_ORDER_SUCCESS:
			return Object.assign({}, state, {
				bookedOrder: action.payload.bookedOrder,
				isFetching: false,
			});

		case REQUEST_FAILURE:
			return Object.assign({}, state, {
				isFetching: false,
				message: action.payload.message,
				error: true,
			});

		case RESET_DATA:
			return Object.assign({}, state, {
				items: [],
				itemsPage: {
					currentPage: 0,
					totalPages: 0,
					totalItems: 0,
					itemsPerPage: 10,
					items: [],
				},
			});

		case SET_ITEMS_PAGE:
			return Object.assign({}, state, {
				itemsPage: action.payload.itemsPage,
			});

		case RESET_FILTERS:
			return Object.assign({}, state, {
				sortFilter: null,
			});

		case SET_SORT_FILTER:
			return Object.assign({}, state, {
				sortFilter: action.payload.sortFilter,
				isFirstLoad: true,
			});

		case SET_ISFIRSTLOAD:
			return Object.assign({}, state, {
				isFirstLoad: action.payload.isFirstLoad,
			});

		case SET_KEYWORD_FILTER:
			return {
				...state,
				keywordFilter: action.payload.keywordFilter,
			};

		default:
			return state;
	}
}

/** Action Creator */
export function getShopOrders(id: string, isFirstLoad: boolean, page?: number) {
	return (dispatch, getState: () => IStore) => {
		if (isFirstLoad) {
			dispatch(resetOrdersData());
			dispatch(setOrdersIsFirstLoad(false));
		}

		dispatch(requestStart());

		const currentPage: number = getState().shopOrders.itemsPage.currentPage;
		const newPage: number = page || currentPage + 1;
		const itemsPerPage: number = getState().shopOrders.itemsPage.itemsPerPage;

		let queryString = '?';
		queryString = queryString + '&currentPage=' + newPage;
		queryString = queryString + '&itemsPerPage=' + itemsPerPage;
		queryString = queryString + '&headerOnly=true';
		//queryString = queryString + '&sortColumn=' + mapOrderItemsSort(getState().shopOrders.sortFilter);

		return fetch(
			getState().fetchDefault.baseAPI + 'api/order/GetByShop/' + id + queryString,
			Object.assign({}, getState().fetchDefault.requestInit),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res) => {
						if (isFirstLoad) {
							dispatch(resetOrdersData());
						}
						const shopOrdersState: IOrdersData = getState().shopOrders;
						const items: IOrderListItem[] = shopOrdersState.items;
						const newItems: IOrderListItem[] = res.items;
						Array.prototype.push.apply(items, newItems);
						dispatch(getOrdersSuccess(items));
						dispatch(setOrderItemsPage(res));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function getOrderById(id: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(requestStart());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/order/' + id,
			Object.assign({}, getState().fetchDefault.requestInit),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res) => {
						dispatch(getOrderSuccess(res));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function setStatus(
	shopOrderId: string,
	shopId: string,
	status: OrderStatus,
	note: string,
	isSingleOrder: boolean = false,
) {
	return (dispatch, getState: () => IStore) => {
		dispatch(requestStart());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/order/' + shopOrderId + '/SetShopOrderStatus/' + status,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'PUT',
				body: JSON.stringify(note),
			}),
		)
			.then((res) => {
				if (res.ok) {
					if (status === OrderStatus.Rejected) {
						dispatch(
							notifSend({
								message: i18n.t('Notification_Success_Order_Cancelled'),
								kind: 'success',
								dismissAfter: 3000,
							}),
						);
					} else if (status === OrderStatus.Processing) {
						// TODO: translation
						dispatch(notifSend({ message: 'Order confirmed.', kind: 'success', dismissAfter: 3000 }));
					}

					if (!isSingleOrder) {
						dispatch(getShopOrders(shopId, true));
					} else {
						dispatch(getShopOrder(shopOrderId, true));
					}
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(notifSend({ message: i18n.t('ErrorPage500_ErrorLabel'), kind: 'error', dismissAfter: 3000 }));
				dispatch(getShopOrders(shopId, true));
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function requestStart(): IOrdersAction {
	return {
		type: REQUEST_START,
	};
}

/** Action Creator */
export function getOrdersSuccess(items: any[]): IOrdersAction {
	return {
		type: GET_SUCCESS,
		payload: {
			items,
		},
	};
}

/** Action Creator */
export function getOrderSuccess(bookedOrder: any): IOrdersAction {
	return {
		type: GET_ORDER_SUCCESS,
		payload: {
			bookedOrder,
		},
	};
}

/** Action Creator */
export function requestFailure(message: any): IOrdersAction {
	return {
		type: REQUEST_FAILURE,
		payload: {
			message,
		},
	};
}

/** Action Creator */
export function resetOrdersData(): IOrdersAction {
	return {
		type: RESET_DATA,
	};
}

export function resetOrdersFilters(): IOrdersAction {
	return {
		type: RESET_FILTERS,
	};
}

/** Action Creator */
export function setOrderItemsPage(itemsPage: IPage): IOrdersAction {
	return {
		type: SET_ITEMS_PAGE,
		payload: {
			itemsPage,
		},
	};
}

export function setOrdersSortFilter(sortFilter: number): IOrdersAction {
	return {
		type: SET_SORT_FILTER,
		payload: {
			sortFilter,
		},
	};
}

export function setOrdersIsFirstLoad(isFirstLoad: boolean): IOrdersAction {
	return {
		type: SET_ISFIRSTLOAD,
		payload: {
			isFirstLoad,
		},
	};
}

export function setKeywordFilter(keywordFilter: string): IOrdersAction {
	return {
		type: SET_KEYWORD_FILTER,
		payload: {
			keywordFilter,
		},
	};
}
